query packagesCube($scenarioId: ID!, $filter: PackageFilterInput!, $originId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    packages(filter: $filter) {
      items {
        id
        code
        index
        isPublished
        population {
          level
          curriculum
          term {
            code
          }
          campus {
            code
          }
          modality {
            code
          }
          shift {
            code
          }
          program {
            code
            name
          }
        }
        __typename
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
    __typename
  }
}
